import '../banners.less';
import './index.less';

import { Col, Row } from 'antd';
import React from 'react';
import Fade from 'react-reveal/Fade';

import ImgBG from '../../../images/bg-all-abilities.jpeg';
import Breakpoint from '../../../utils/breakpoint';
import Title from '../../BannerShared/Title';

const AllAbilities = () => (
  <div className="banner banner-all-abilities">
    <div className="container">
      <Breakpoint min="sm">
        <div className="ksp-wrapper">
          <div className="ksp-bg">#suitableforall</div>
        </div>
      </Breakpoint>
      <Breakpoint max="lg">
        <Row gutter={40} justify="center">
          <Col xs={{ span: 24, order: 2 }} md={{ span: 20, order: 1 }}>
            <Fade>
              <section>
                <Title title="Suitable for All" isTagline isCenter />
                <Title title="A Workout For All Abilities" />
              </section>
            </Fade>
          </Col>
        </Row>
        <Row gutter={40} justify="center">
          <Col xs={{ span: 24, order: 1 }} md={{ span: 24, order: 2 }}>
            <Fade>
              <section>
                <img src={ImgBG} className="bg-img" alt="" />
              </section>
            </Fade>
          </Col>
        </Row>
      </Breakpoint>
      <Breakpoint min="lg">
        <Row gutter={40}>
          <Col span={24}>
            <Fade>
              <section>
                <Title title="A Workout For All Abilities" />
              </section>
            </Fade>
          </Col>
        </Row>
        <Row>
          <Col>
            <img src={ImgBG} className="bg-img" alt="" />
          </Col>
        </Row>
      </Breakpoint>
    </div>
  </div>
);

export default AllAbilities;
